import React from "react";

import ReactPlayer from "react-player";
function SpecialproductsSingle({ productDetails }) {
  const benefits = productDetails?.special_details?.benefits;
  const what_inside = productDetails?.special_details?.what_inside;
  const how = productDetails?.special_details?.how;
  const why = productDetails?.special_details?.why;
  const ref = productDetails?.special_details?.ref;

  return (
    <>
      <section className="special_products_single_products ">
        <div className="container">
          <div className="row pt-40 pb-40">
            <div className="col-12">
              <div className="benefits_inner_box">
                {benefits.benefits_title || "No title available"}{" "}
                <img src={benefits.benefits_image} alt="img" />
                <div
                  dangerouslySetInnerHTML={{
                    __html: benefits.benefits_description,
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="whats_inside_section">
        <div className="container">
          <div className="row pt-40 pb-40">
            <h5
              style={{ color: "#042117", fontWeight: "600" }}
              className="mb-4"
            >
              {what_inside.what_inside_title}
            </h5>
            <div className="col-lg-3 col-md-3 col-sm-12 left_col">
              <div className="img_box">
                <img src={what_inside.what_inside_image} alt="img" />
              </div>
            </div>
            <div className="col-lg-9 col-md-9 col-sm-12 right_col">
              <div
                className="inner_box"
                dangerouslySetInnerHTML={{
                  __html: what_inside.what_inside_description,
                }}
              ></div>
            </div>
          </div>
        </div>
      </section>

      <section className="how_to_made_section">
        <div className="container">
          <div className="row pt-40 pb-40">
            <div className="col-lg-7 col-md-7 col-sm-12 left_col">
              <div className="inner_box">
                <h5
                  style={{ color: "#042117", fontWeight: "600" }}
                  className="mb-4"
                >
                  {how.how_title}
                </h5>

                <div
                  className="list_box"
                  dangerouslySetInnerHTML={{ __html: how.how_description }}
                ></div>
              </div>
            </div>
            <div className="col-lg-5 col-md-5 col-sm-12 right_col">
              <div className="img_box">
                <img src={how.how_image} alt="img" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="why_choose_section">
        <div className="container">
          <div className="row pt-40 pb-40">
            <h5
              style={{ color: "#042117", fontWeight: "600" }}
              className="mb-4"
            >
              {why.why_title}
            </h5>
            <div className="col-lg-3 col-md-3 col-sm-12 left_col">
              <div className="img_box">
                <img src={why.why_image} alt="img" />
              </div>
            </div>
            <div className="col-lg-9 col-md-9 col-sm-12 right_col">
              <div
                className="inner-box"
                dangerouslySetInnerHTML={{ __html: why.why_description }}
              ></div>
            </div>
          </div>
        </div>
      </section>

      <section className="video_section pt-40 pb-40">
        <div className="container">
          <div className="row first_row">
            <div className="col-12">
              <h5 style={{ color: "#042117", fontWeight: "600" }}>
                {ref.ref_title}
              </h5>
              <p
                className="mb-0"
                dangerouslySetInnerHTML={{ __html: why.why_description }}
              ></p>
            </div>
          </div>
          <div
            className="row second_row mt-4"
            style={{ justifyContent: "center" }}
          >
            <div className="col-lg-7 col-md-12 col-sm-12">
              {/* <iframe
                width="100%"
                height="315"
                src="https://www.youtube.com/embed/M0sJl_TKgXQ?si=9e82SKHDHzvuPfaY"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe> */}
              <div>
                <ReactPlayer
                  url={ref.ref_youtube_link}
                  playing={false}
                  controls={false}
                  width="100%"
                  height="200px"
                  muted={true}
                  config={{
                    youtube: {
                      playerVars: {
                        rel: 0, // prevents related videos at the end
                        modestbranding: 1, // hides the YouTube logo
                        disablekb: 1, // disables the keyboard controls
                      },
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SpecialproductsSingle;
